import { Injectable, signal } from '@angular/core';

export type CorrelationHoverSection = 'equation' | 'slope' | 'intercept';
export type CorrelationHoverSource = 'grid' | 'chart';

@Injectable()
export class CorrelationStore {
  readonly hoveredSection = signal<CorrelationHoverSection | null>(null);
  readonly hoveredPointIndex = signal<number | null>(null);
  readonly hoveredPointSource = signal<CorrelationHoverSource | null>(null);

  hoverSection(section: CorrelationHoverSection | null): void {
    this.hoveredSection.set(section);
  }

  hoverPoint(index: number | null, source: CorrelationHoverSource): void {
    this.hoveredPointIndex.set(index);
    this.hoveredPointSource.set(index !== null ? source : null);
  }
}
